import { render, staticRenderFns } from "./OnboardingIdeaStageCard.vue?vue&type=template&id=3fa9f588&scoped=true"
import script from "./OnboardingIdeaStageCard.vue?vue&type=script&lang=js"
export * from "./OnboardingIdeaStageCard.vue?vue&type=script&lang=js"
import style0 from "./OnboardingIdeaStageCard.vue?vue&type=style&index=0&id=3fa9f588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa9f588",
  null
  
)

export default component.exports